import React from 'react'
import styles from './Popovers.scss'
import {Popover} from 'common/styleguide/Popover'
import {PopoverMenu, PopoverMenuItem, PopoverMenuHeading} from 'common/styleguide/PopoverMenu'
import {PopoverLinkMenu, PopoverLinkMenuItem, PopoverLinkMenuHeading} from 'common/styleguide/PopoverLinkMenu'
import {CTA} from 'common/styleguide/CTA'
import {OrderedMap, Set} from 'immutable'
import {RadioGroup} from 'common/styleguide/RadioGroup'
import {CheckboxGroup} from 'common/styleguide/CheckboxGroup'
const noop = () => {}

const POSITIONS = ['top', 'right', 'bottom', 'left']

const overlays = OrderedMap({
  cake: 'Cake',
  pie: 'Pie',
  distanceMarkerOverlay: 'Distance Markers'
})

const actions = OrderedMap({
  solveFerry: 'Solve for Ferry',
  solvePeace: 'Solve for World Peace'
})

export class Popovers extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      position: 0
    }
  }
  setRef1 = (ref) => {
    this._ref1 = ref
  }

  setRef2 = (ref) => {
    this._ref2 = ref
  }

  setRef3 = (ref) => {
    this._ref3 = ref
  }

  setRef4 = (ref) => {
    this._ref4 = ref
  }

  changePosition = () => {
    this.setState({position: (this.state.position + 1) % 4})
  }

  // popover prooooobably needs ref to be set on first render, and it's not
  // being populated until after the layout runs... dumb race conditions
  // are dumb
  render () {
    const {position} = this.state

    return (
      <div>
        <h1>Popovers</h1>
        <p>Popover with <code>insideMargin = true</code></p>
        <div className={styles.demoContainer}>
          <CTA inline ref={this.setRef1} onClick={this.changePosition}>
            Click Me to Change Position
          </CTA>
          <Popover
            container={window.body}
            target={() => this._ref1}
            placement={POSITIONS[position]}
            onRequestClose={noop}>
            <h3>Popover</h3>
            <div>position: {POSITIONS[position]}</div>
          </Popover>
        </div>
        <p>Popover with <code>insideMargin = false</code></p>
        <div className={styles.demoContainer}>
          <CTA inline ref={this.setRef2} onClick={this.changePosition}>
            Click Me to Change Position
          </CTA>
          <Popover
            container={window.body}
            target={() => this._ref2}
            insideMargin={false}
            placement={POSITIONS[position]}
            onRequestClose={noop}>
            <h3>Popover</h3>
            <div>position: {POSITIONS[position]}</div>
          </Popover>
        </div>
        <h2>PopoverMenu</h2>
        <PopoverMenu // problem: react-overlays is not allowing container overflow
          container={window.body}
          target={() => this._ref4}
          insideMargin={false}
          placement='bottom'
          onRequestClose={noop}>
          <PopoverMenuHeading>A menu heading</PopoverMenuHeading>
          <PopoverMenuItem>
            <RadioGroup style={{margin: '0 0'}} horizontal options={overlays} selected='cake' />
          </PopoverMenuItem>
          <PopoverMenuHeading>Another menu heading</PopoverMenuHeading>
          <PopoverMenuItem>
            <CheckboxGroup style={{margin: '0 0'}} horizontal options={actions} selected={Set(['solveFerry'])} />
          </PopoverMenuItem>
        </PopoverMenu>
        <p><a ref={this.setRef4} style={{display: 'inline-block'}}>More Options</a></p>
        <p>
          Martens liege-bastogne-liege res firma mitescere nescit rund um koln
          as the toto turns, as the toto turns cassette choley pays de loire cat
          among the pigeons cycles goff flanders. Nevele bianchi bruges
          randonneur schleck koppenberg, planckaert ronde van belgie boonen res
          firma mitescere nescit the. Cog echelon, meyrueis lanterne rouge
          commissaire with rouleur derby arriere du peloton.
        </p>
        <p>
          Martens liege-bastogne-liege res firma mitescere nescit rund um koln
          as the toto turns, as the toto turns cassette choley pays de loire cat
          among the pigeons cycles goff flanders. Nevele bianchi bruges
          randonneur schleck koppenberg, planckaert ronde van belgie boonen res
          firma mitescere nescit the. Cog echelon, meyrueis lanterne rouge
          commissaire with rouleur derby arriere du peloton.
        </p>
        <h2>PopoverLinkMenu</h2>
        <p><a ref={this.setRef3} style={{display: 'inline-block'}}>More Options</a></p>
        <PopoverLinkMenu // problem: react-overlays is not allowing container overflow
          container={window.body}
          target={() => this._ref3}
          insideMargin={false}
          placement='bottom'
          onRequestClose={noop}>
          <PopoverLinkMenuHeading>A menu heading</PopoverLinkMenuHeading>
          <PopoverLinkMenuItem>Export GPX file</PopoverLinkMenuItem>
          <PopoverLinkMenuItem>Re-fetch Elevations</PopoverLinkMenuItem>
          <PopoverLinkMenuHeading>Another menu heading</PopoverLinkMenuHeading>
          <PopoverLinkMenuItem>Solve for Ferry</PopoverLinkMenuItem>
          <PopoverLinkMenuItem>Render a Big One</PopoverLinkMenuItem>
          <PopoverLinkMenuItem>Call Roberto Rigoli</PopoverLinkMenuItem>
        </PopoverLinkMenu>
        <p>
          Martens liege-bastogne-liege res firma mitescere nescit rund um koln
          as the toto turns, as the toto turns cassette choley pays de loire cat
          among the pigeons cycles goff flanders. Nevele bianchi bruges
          randonneur schleck koppenberg, planckaert ronde van belgie boonen res
          firma mitescere nescit the. Cog echelon, meyrueis lanterne rouge
          commissaire with rouleur derby arriere du peloton.
        </p>
        <p>
          Martens liege-bastogne-liege res firma mitescere nescit rund um koln
          as the toto turns, as the toto turns cassette choley pays de loire cat
          among the pigeons cycles goff flanders. Nevele bianchi bruges
          randonneur schleck koppenberg, planckaert ronde van belgie boonen res
          firma mitescere nescit the. Cog echelon, meyrueis lanterne rouge
          commissaire with rouleur derby arriere du peloton.
        </p>
      </div>
    )
  }
}
